import { createSlice, PayloadAction } from "@reduxjs/toolkit"

import { Call } from "@modules/Call/sdk"

interface CallState {
    currentCall: Call | undefined
}

const initialState: CallState = {
    currentCall: undefined,
}

const callSlice = createSlice({
    name: "call",
    initialState,
    reducers: {
        changeCall(state, action: PayloadAction<Call | undefined>) {
            state.currentCall = action.payload
        },
        clearCall(state) {
            state.currentCall = undefined
        },
    },
})

export const callReducer = callSlice.reducer
export const { changeCall, clearCall } = callSlice.actions
